/*
 * @Descripttion: 
 * @version: 
 * @Author: jinfjk
 * @Date: 2020-08-17 09:56:43
 * @LastEditors: bbq
 * @LastEditTime: 2021-01-25 19:25:48
 */
import React, { Component } from 'react';
import { PubSub } from '@platform/api';
import executeAutoFocus from './executeAutoFocus';

const { matchItemFocus } = executeAutoFocus;

function FormWithAutoFocus(WrappedComponent) {
    return class WithAutoFocus extends Component {
        componentDidMount() {
            let { name, form } = this.props;

            this.autoFocusToken = PubSub.subscribe('autoFocus', (msg, { data, id }) => {
                let selector = `[hotkeytag="${name}-${data}"]`;
                let itemtype = 'normal';
                if (form && data) {
                    form.setItemAttribute(data, 'autoFocus', true);
                    itemtype = form.getItemAttribute(data, 'itemtype');
                }
                console.log(selector, form, id, data, itemtype);

                // 表单
                if (id) {
                    if (name === id) {
                        console.log(id)
                        // 如果没有获取到对应的itemtype 就统一用normal来处理， 如果碰到特殊的就在往matchItemFocus里加
                        matchItemFocus[itemtype] === undefined
                            ? matchItemFocus['normal'](selector)
                            : matchItemFocus[itemtype](selector);
                    }
                } else {
                    if (data) {
                        // 如果没有获取到对应的itemtype 就统一用normal来处理， 如果碰到特殊的就在往matchItemFocus里加
                        matchItemFocus[itemtype] === undefined
                            ? matchItemFocus['normal'](selector)
                            : matchItemFocus[itemtype](selector);
                    }
                }
            });
        }

        componentWillUnmount() {
            // this.dom = null;
            this.autoFocusToken && PubSub.unsubscribe(this.autoFocusToken);
        }

        render() {
            // console.log(this.props.children);
            return (
                <WrappedComponent
                    // ref={dom => {
                    //     console.log(dom);
                    //     this.dom = dom;
                    // }}
                    {...this.props}
                />
            );
        }
    };
}

export default FormWithAutoFocus;